import { render, staticRenderFns } from "./AmetrasUploadFieldTemplate.vue?vue&type=template&id=1fad208a&scoped=true&"
import script from "./AmetrasUploadFieldTemplate.vue?vue&type=script&lang=ts&"
export * from "./AmetrasUploadFieldTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./AmetrasUploadFieldTemplate.vue?vue&type=style&index=0&id=1fad208a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fad208a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VAvatar,VBtn,VChip,VIcon,VProgressCircular,VProgressLinear})
